export const BRAND_ASSET_VERSION_QUERY = `?v=${BUILD_ID_GLOBAL}`;
